(function () {
  function buildWhatsAppMessage(template, title, url) {
    return template.replace(/\[title\]/g, title).replace(/\[url\]/g, url);
  }

  function initWhatsAppBuyButtons() {
    document.querySelectorAll('[data-whatsapp-buy]').forEach((button) => {
      if (button.dataset.whatsappBound === 'true') return;

      button.dataset.whatsappBound = 'true';
      button.addEventListener('click', () => {
        const phone = button.dataset.whatsappPhone;
        const template = button.dataset.whatsappMessage || 'Olá, gostaria de comprar esse produto: [url]';
        const title = button.dataset.productTitle || document.title;
        const message = buildWhatsAppMessage(template, title, window.location.href);

        if (!phone) return;

        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatsAppBuyButtons);
  } else {
    initWhatsAppBuyButtons();
  }

  document.addEventListener('shopify:section:load', initWhatsAppBuyButtons);
})();
